import { useEffect } from "react";
import ReactDOM from "react-dom";
import { JavascriptViewer } from "@3dweb/360javascriptviewer";
import { useConfig } from "../context";

const Product360ViewerPromo = (props) => {
  const { fotos360Url } = useConfig();

  useEffect(() => {
    const jsv = new JavascriptViewer({
      mainHolderId: "jsv-holder",
      mainImageId: "jsv-image",
      totalFrames: 19,
      imageUrlFormat: "img_0_0_x.jpg",
      speed: 80,
      defaultProgressBar: true,
      inertia: 20,
      reverse: true,
      autoRotate: 2,
      autoRotateSpeed: -150,
    });

    jsv.start();
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal">
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            {props.item.Familia} {props.item.Codigo} (360)
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            onClick={props.closeModal}
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body">
          <div id="jsv-holder" className="jsv-holder-360">
            <img
              id="jsv-image"
              alt={props.item.Codigo}
              src={
                props.catalogo
                  ? fotos360Url +
                    props.item.Codigo.toUpperCase() +
                    "/images/img_0_0_0.jpg"
                  : fotos360Url +
                    props.item.RutaImages +
                    "/img_0_0_0.jpg"
              }
              className="image-zoom-img"
            />
          </div>
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Product360ViewerPromo;
